import axios from "axios";
import router from "../router";
import qs from "qs";
import { apiURL,newApiURL } from "./config";
import EventBus from "@/utils/event-bus";

const onUnauthorized = () => {};

const RESULTCODE = {
  INVALIDE_PARAMETER: "INVALID_PARAMETER",
  SUCCEEDED: "SUCCEEDED",
  ERROR: "ERROR",
};
export const setAuthInHeader = token => {
  axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : '';
};
export const removeAuthInHeader = () => {
  delete axios.defaults.headers.common['Authorization'];
};
axios.defaults.paramsSerializer = params => {
  return qs.stringify(params, { arrayFormat: 'repeat' });
};
export const request = {
    get(path, params=null) {
        return axios.get(`${apiURL + path}`, {params: params})
            .then(res => {
                return res;
            }).catch(({response}) => {
                //router.push('/')
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203){
                    return onUnauthorized();
                }
                return response
            })
    },
    delete(path, params=null) {
        return axios.delete(`${apiURL + path}`, {data: params})
            .then(res => {
                return res;
            }).catch(({response}) => {
                //router.push('/')
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203){
                    return onUnauthorized();
                }
                return response
            })
    },
    post(path, data) {
        return axios.post(`${apiURL + path}`, data)
            .then(res => {
                return res;
            }).catch(({response}) => {
                //router.push('/')
                if (response == undefined){
                    return response
                }
                const {status} = response.data.code;
                if (response == undefined || status === 201 || status === 202 || status === 203){
                    return onUnauthorized();
                }
                return response
            })
    },
    put(path, data) {
        return axios.put(`${apiURL + path}`, data)
            .then(res => {
                return res;
            }).catch(({response}) => {
                //router.push('/')
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203){
                    return onUnauthorized();
                }
                return response
            })
    },
    patch(path, data) {
        return axios.patch(`${apiURL + path}`, data)
            .then(res => {
                return res;
            }).catch(({response}) => {
                //router.push('/')
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203){
                    return onUnauthorized();
                }
                return response
            })
    },

    newGet(path, params=null) {
        return axios.get(`${newApiURL + path}`, {params: params})
            .then(res => {
                return res;
            }).catch(({response}) => {
                //router.push('/')
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203){
                    return onUnauthorized();
                }
                return response
            })
    },
    newDelete(path, params=null) {
        return axios.delete(`${newApiURL + path}`, {data: params})
            .then(res => {
                return res;
            }).catch(({response}) => {
                //router.push('/')
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203){
                    return onUnauthorized();
                }
                return response
            })
    },
    newPost(path, data) {
        return axios.post(`${newApiURL + path}`, data)
            .then(res => {
                return res;
            }).catch(({response}) => {
                //router.push('/')
                if (response == undefined){
                    return response
                }
                const {status} = response.data.code;
                if (response == undefined || status === 201 || status === 202 || status === 203){
                    return onUnauthorized();
                }
                return response
            })
    },
    newPut(path, data) {
        return axios.put(`${newApiURL + path}`, data)
            .then(res => {
                return res;
            }).catch(({response}) => {
                //router.push('/')
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203){
                    return onUnauthorized();
                }
                return response
            })
    },
    newPatch(path, data) {
        return axios.patch(`${newApiURL + path}`, data)
            .then(res => {
                return res;
            }).catch(({response}) => {
                //router.push('/')
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203){
                    return onUnauthorized();
                }
                return response
            })
    },
};
